module.exports = __webpack_public_path__ + "static/media/AMCV.6f7b29db.pdf";